import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import VueRouterBackButton from 'vue-router-back-button'
import VueAnalytics from 'vue-analytics'
import { analytics, auth } from './config'

Vue.use(Router)

const routerOptions = [
  { path: '/', name: 'HomeInicial', component: 'HomeInicial' },
  { path: '/home', name: 'Home', component: 'Home' },
  // { path: '/mylist', name: 'MyList', component: 'MyList' },
  // { path: '/search', name: 'Search', component: 'Search' },
  // { path: '/catalogo', name: 'Catalogo', component: 'Search' },
  { path: '/programs/:slug', name: 'Program', component: 'Program' },
  { path: '/programs/:id', name: 'ProgramId', component: 'Program' },
  // { path: '/about', name: 'About', component: 'About' },
  { path: '/signin', name: 'Signin', component: 'Signin' },
  { path: '/signup', name: 'Signup', component: 'Signup', meta: { keep: true } },
  // { path: '/sanvalentin', name: 'SanValentin', component: 'SanValentin', redirect: '/registro' },
  // { path: '/sitges', name: 'Signin', component: 'Signup' },
  // { path: '/navidad', name: 'Signin', component: 'Signup' },
  // { path: '/nocturna', name: 'Signin', component: 'Signup' },
  // { path: '/molins', name: 'Signin', component: 'Signup' },
  // { path: '/samsung', name: 'Signin', component: 'Signup' },
  // { path: '/Sitges', name: 'Signin', component: 'Signup' },
  // { path: '/Nocturna', name: 'Signin', component: 'Signup' },
  // { path: '/Molins', name: 'Signin', component: 'Signin' },
  { path: '/email', name: 'E-mail', component: 'Email', meta: { keep: true } },
  { path: '/password', name: 'Password', component: 'Password', meta: { keep: true } },
  { path: '/notifications', name: 'Notifications', component: 'Notifications', meta: { keep: true } },
  { path: '/app_mobile', name: 'AppMobile', component: 'AppMobile', meta: { keep: true } },
  { path: '/signout', name: 'Signout', component: 'Signout' },
  { path: '/video/:slug', name: 'Video', component: 'Video', meta: {
    requiresAuth: true,
    requiresAge: true,
    requiresMembership: true,
    geoblocked: true }
  },
  { path: '/video/:id', name: 'VideoId', component: 'Video', meta: {
    requiresAuth: true,
    requiresAge: true,
    requiresMembership: true,
    geoblocked: true }
  },
  { path: '/live/:slug', name: 'Live', component: 'Live', meta: {
    requiresAuth: true,
    requiresAge: true,
    requiresMembership: true,
    geoblocked: true }
  },
  // { path: '/subscription', name: 'Subscription', component: 'Subscription', meta: { requiresAuth: true, keep: true, geoblocked: true } },
  { path: '/reset_password', name: 'ResetPassword', component: 'ResetPassword', meta: { keep: true } },
  { path: '/change_password', name: 'ChangePassword', component: 'ChangePassword', meta: { requiresAuth: true } },
  { path: '/profile', name: 'Profile', component: 'Profile', meta: { requiresAuth: true } },
  { path: '/faq', name: 'Contact', component: 'Contact' },
  { path: '/terminos-y-condiciones', name: 'Terms', component: 'Terms' },
  { path: '/politica-de-privacidad', name: 'Privacy', component: 'Terms' },
  { path: '/incompatibility', name: 'Incompatibility', component: 'Incompatibility' },
  { path: '/incompatibility_desktop', name: 'IncompatibilityDesktop', component: 'IncompatibilityDesktop' },
  // { path: '/suscripcion_finalizada', name: 'PaymentSuccess', component: 'PaymentSuccess', meta: { keep: true } },
  { path: '/geo_blocked', name: 'GeoBlocked', component: 'GeoBlocked', meta: { keep: true } },
  // { path: '/theo', name: 'Theo', component: 'Theo' },
  // { path: '/theo2', name: 'Theo2', component: 'Theo2' },
  { path: '*', name: 'NotFound', component: 'NotFound' }
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import (`@/views/${route.component}.vue`)
  }
})

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const handleQuery = (to, from) => {
  if (Object.keys(from.query).length) {
    return JSON.stringify(from.query) !== JSON.stringify(to.query)
  }
}
const canonicalTag = (to) => {
  const rel = document.head.querySelector('link[rel=canonical]')
  const loc = window.location
  rel.href = `${loc.protocol}//${loc.host}${to.path}`
  console.log(document.head.querySelector('link[rel=canonical]'))
}

router.beforeEach(async(to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAge = to.matched.some(record => record.meta.requiresAge)
  const keep = to.matched.some(record => record.meta.keep)
  const requiresMembership = to.matched.some(record => record.meta.requiresMembership)
  const geoblocked = to.matched.some(record => record.meta.geoblocked)
  const isAuthenticated = store.getters.isAuthenticated || localStorage.getItem('user')
  // if (requiresMembership) await store.dispatch('checkSubscription')

  canonicalTag(to)
  console.log({from})
  console.log(auth.currentUser)
  if (to.name === 'Privacy') {
    location.href = 'https://amcnetworks.es/microcanales/politica-de-privacidad'
    next(false)
  } else if (to.name === 'HomeInicial' && isAuthenticated && auth.currentUser !== null) {
    next({ path: '/home', replace: true })
  // } else if (from.path === '/' && to.path === '/' && (window.ios || window.android)) {
    // next({ name: 'AppMobile', query: from.query, replace: true })
  } if (requiresAuth && (!isAuthenticated || auth.currentUser === null)) {
    const query = to.path.length > 2 ? { from: to.path } : null
    next({ path: '/signin', query, replace: true })
    canonicalTag({ path: '/signin' })
  } else if (geoblocked && !window.ip2_ok) {
    next({ name: 'GeoBlocked', query: from.query })
    canonicalTag({ path: 'geo_blocked' })
  } else if (keep && handleQuery(to, from)) {
    next({ path: to.path, query: from.query, replace: true })
  } else {
    next()
  }
})

Vue.use(VueAnalytics, {
  id: analytics,
  router
})

Vue.use(VueRouterBackButton, { router })

export default router
